import script from "./TaskCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCenter.vue?vue&type=script&setup=true&lang=js"

import "./TaskCenter.vue?vue&type=style&index=0&id=90697e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90697e66"]])

export default __exports__